import { FilterField } from '@totem/components/ui_components/reportSettings/types';

export const salesOrdersContainerConfiguration: FilterField[] = [
  {
    key: 'salesOrder',
    label: 'Sales Order',
    sortField: 'nsSalesOrder.tranId',
    filterField: 'nsSalesOrder.tranId',
    multiple: false,
    operator: 'cscontains',
    values: [],
  },
  {
    key: 'line',
    label: 'Line',
    sortField: 'nsSalesOrderLine.line',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'description',
    label: 'Description',
    sortField: 'nsSalesOrderLine.description',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'startDate',
    label: 'Start Date',
    sortField: 'startDate',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'endDate',
    label: 'End Date',
    sortField: 'endDate',
    filterField: '',
    multiple: false,
    values: [],
  },
  {
    key: 'region',
    label: 'Region',
    sortField: 'region.name',
    filterField: 'region.id',
    multiple: true,
    values: [],
  },
  {
    key: 'building',
    label: 'Building',
    sortField: 'building.name',
    filterField: 'building.id',
    multiple: true,
    values: [],
  },
  {
    key: 'service',
    label: 'Service',
    sortField: 'services.name',
    filterField: 'services.id',
    multiple: true,
    values: [],
  },
  {
    key: 'status',
    label: 'Status',
    sortField: 'status',
    filterField: 'status',
    multiple: true,
    values: [],
    options: [
      { text: 'Active', value: 'Active' },
      { text: 'Canceled', value: 'Canceled' },
      { text: 'Expired', value: 'Expired' },
      { text: 'Information', value: 'Information' },
      { text: 'Pending', value: 'Pending' },
      { text: 'Pending Dates', value: 'Pending Dates' },
      { text: 'Provisioning', value: 'Provisioning' },
      { text: 'Project Complete', value: 'Project Complete' },
    ],
  },
];
